import { render, staticRenderFns } from "./LogoutUte.vue?vue&type=template&id=c731f3da&"
import script from "./LogoutUte.vue?vue&type=script&lang=js&"
export * from "./LogoutUte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports